import React from 'react'

export const BackButton = (props) => {
  return (
    <button className='button-back' onClick={() => props.onClick()}>
      <svg  xmlns="http://www.w3.org/2000/svg" height="44px" viewBox="0 -960 960 960" width="44px" fill="rgba(34, 68, 84, 0.67)">
      <path d="M398.5-120.5 39-480l359.5-359.5 32 31.5-328 328 328 327.5-32 32Z"/></svg>
    </button>
  )
}
